import { PRO_MODELS_TEXT } from '../../constants/aiModels';

// 공지사항 (최신순)
export const NOTICES = [
  {
    id: 'knue-pilot-recruit-2026-11',
    date: '2026-11-04',
    title: '한국교원대 x 왓퀴즈AI 활용 실증 참여교사 모집',
    summary: '수업에 왓퀴즈AI를 써 보고 의견을 나눠 주실 선생님 10분을 모셔요. 교사 활동비 30만 원을 드려요. 11월 9일(월) 15시까지 신청해 주세요.',
    isImportant: false,
    content: `
      <p>안녕하세요, 팀왓퀴즈입니다.</p>
      <p>한국교원대학교 Anchor 사업단과 함께 <strong>왓퀴즈AI 활용 실증(에듀테크 실증 4기)</strong>에 참여하실 선생님을 모셔요. 실제 수업에서 왓퀴즈AI를 써 보시고, 어떤 점이 도움이 되었는지 알려 주시면 돼요.</p>

      <div style="background: #f2f4f6; border: 1px solid #e5e8eb; border-radius: 12px; padding: 20px; margin: 16px 0;">
        <p style="color: #191f28; margin: 0 0 8px 0; font-size: 16px; font-weight: 700;">11월 9일(월) 15시까지 신청해 주세요</p>
        <p style="margin: 0; color: #333d4b; line-height: 1.7;">최대 10분을 모셔요. 참여하시는 선생님께는 <strong>교사 활동비 30만 원</strong>을 드리고, 실증 기간 동안 <strong>왓퀴즈AI를 무료로</strong> 쓰실 수 있어요.</p>
        <p style="margin: 12px 0 0 0;"><a href="https://drive.google.com/drive/folders/1IpAiX9vnibiTCEOP1HA_zVdPAIMohOKK?usp=sharing" target="_blank" rel="noopener noreferrer" style="color: #3182f6; font-weight: 700;">신청 양식·소개서 받기 →</a></p>
        <p style="margin: 8px 0 0 0;"><a href="https://forms.gle/StpcFJkZwt6u82y78" target="_blank" rel="noopener noreferrer" style="color: #3182f6; font-weight: 700;">참여 신청하기 →</a></p>
      </div>

      <h3>신청할 때 필요한 자료</h3>
      <p>아래 자료실에서 내려받으실 수 있어요.</p>
      <ul>
        <li><strong>수업 계획서 양식(한글 파일):</strong> 「에듀테크 활용 수업 계획서_실증 참여교사 신청용」. 내려받아 작성한 뒤 신청해 주세요.</li>
        <li><strong>왓퀴즈 소개서(PDF):</strong> 수업 계획을 세우실 때 왓퀴즈AI로 무엇을 할 수 있는지 참고하세요.</li>
        <li><strong>모집 포스터(PDF)</strong></li>
      </ul>
      <p><a href="https://drive.google.com/drive/folders/1IpAiX9vnibiTCEOP1HA_zVdPAIMohOKK?usp=sharing" target="_blank" rel="noopener noreferrer" style="color: #3182f6; font-weight: 700;">자료실 열기 (구글 드라이브) →</a></p>

      <h3>모집 안내</h3>
      <ul>
        <li><strong>대상:</strong> 전국 초·중·고 현직 교사 및 강사 (학교급 상관없어요)</li>
        <li><strong>신청 기간:</strong> 2026년 10월 13일(화) ~ 11월 9일(월) 15:00</li>
        <li><strong>선정 인원:</strong> 최대 10명</li>
        <li><strong>사전 회의:</strong> 11월 10일(화) 17:00, 줌 온라인 (꼭 참석해 주세요)</li>
        <li><strong>혜택:</strong> 교사 활동비 30만 원, 왓퀴즈AI 무료 이용</li>
      </ul>

      <h3>이것만 해 주세요</h3>
      <ol>
        <li>연구소에서 요청하는 자료를 내고 수업 계획을 세워요.</li>
        <li>실제 수업에 적용하고, 1회(1차시) 수업 영상을 찍어요.</li>
        <li>촬영한 수업의 수업 계획서와 평가서를 써요.</li>
      </ol>

      <h3>모집 포스터</h3>
      <img src="/images/help/knue-pilot-recruit-2026-11/poster.jpg" alt="한국교원대학교 x 왓퀴즈AI 활용 실증 참여교사 모집 포스터. 전국 초·중·고 현직 교사 및 강사 최대 10명, 신청 기간 2026년 10월 13일(화)부터 11월 9일(월) 15시까지, 사전 회의 11월 10일(화) 17시 줌, 교사 활동비 30만 원 지급과 왓퀴즈AI 무상 이용." style="width: 100%; max-width: 560px; border-radius: 12px; border: 1px solid #e5e8eb; margin: 8px 0;" loading="lazy" />

      <h3>문의</h3>
      <ul>
        <li><strong>한국교원대학교 Anchor 사업단:</strong> 043-230-3856</li>
        <li><strong>왓퀴즈:</strong> <a href="mailto:angel@plactical.com" style="color: #1a73e8;">angel@plactical.com</a></li>
      </ul>

      <p>선생님들의 의견으로 왓퀴즈를 더 좋게 만들어 볼게요. 감사합니다.</p>
    `,
  },
  {
    id: 'privacy-policy-update-2026-11-ai-reference-default-on',
    date: '2026-11-04',
    title: '개인정보처리방침 변경 안내 (2026.11.4 시행)',
    summary: '채팅 파일 모아 두기와 지난 대화 찾아보기를 기본으로 켜요. 이미 허용 안 함을 고른 분은 계속 꺼져 있어요.',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>"지난번 파일로 이 양식 채워 줘"처럼 예전 자료를 찾아 쓰는 일이 많아서, <strong>내 자료함 자동 모으기</strong>와 <strong>지난 대화 찾아보기</strong>를 처음부터 켜 두기로 했어요. 원하지 않으시면 <strong>AI 맞춤 설정</strong>에서 언제든 끌 수 있어요.</p>

      <h3>시행일</h3>
      <p><strong>2026년 11월 4일(수)</strong>부터 바뀐 개인정보처리방침이 적용돼요.</p>

      <h3>무엇이 바뀌나요</h3>
      <ul>
        <li><strong>기본으로 켜져요</strong> - 따로 허용하지 않아도 채팅에 올린 문서 파일을 내 자료함에 모아 두고, 지난 대화를 필요할 때 찾아 써요.</li>
        <li><strong>끈 분은 그대로예요</strong> - 이미 '허용 안 함'을 고르셨거나 설정에서 끄신 분은 계속 꺼져 있어요.</li>
        <li><strong>보호 조치는 그대로예요</strong> - 학생 명단·성적표·상담 기록·생활기록부처럼 학생 정보로 보이는 파일은 모으지 않고, 지난 대화도 학생 이름은 가린 채로 참고해요. 광고·판매·모델 학습에는 쓰지 않아요.</li>
      </ul>

      <h3>바뀌기 전과 후</h3>
      <table>
        <thead>
          <tr>
            <th>조항</th>
            <th>바뀌기 전</th>
            <th>바뀐 후</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>제1조 ① 수집 항목 · 제2조 처리 목적</td>
            <td>(이용자가 허용한 경우)</td>
            <td>(이용자가 끄지 않은 경우)</td>
          </tr>
          <tr>
            <td>제3조의5 ①</td>
            <td>채팅 화면의 안내 또는 AI 맞춤 설정에서 허용한 경우에만 동작</td>
            <td>기본으로 켜져 있고 AI 맞춤 설정에서 각각 끄거나 다시 켤 수 있음. '허용 안 함'을 골랐거나 설정에서 끈 이용자는 꺼진 상태 유지</td>
          </tr>
        </tbody>
      </table>

      <h3>끄고 싶으시면</h3>
      <p><strong>AI 맞춤 설정 → AI가 찾아 쓰는 자료</strong>에서 '채팅에 올린 파일 모아 두기'와 '지난 대화 찾아보기'를 각각 끌 수 있어요. 끄면 그때부터 모으거나 찾지 않고, 이미 모아 둔 파일은 참고 자료에서 지울 수 있어요.</p>

      <h3>바뀐 방침 전문 보기</h3>
      <p><a href="/privacy-policy" style="color: #3182f6; font-weight: 600;">개인정보처리방침 보기</a></p>

      <h3>문의</h3>
      <p>바뀐 내용이 궁금하시면 개인정보 보호책임자에게 연락해 주세요.</p>
      <ul>
        <li><strong>이메일:</strong> angel@plactical.com</li>
        <li><strong>전화:</strong> 02-949-9158</li>
      </ul>
    `,
  },
  {
    id: 'privacy-policy-update-2026-11-ai-reference',
    date: '2026-11-02',
    title: '개인정보처리방침 변경 안내 (2026.11.2 시행)',
    summary: '채팅 파일을 내 자료함에 모아 두고 지난 대화를 참고하는 내용, 생기부 근거 보기 자료 보관을 방침에 담았어요.',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>채팅에 올린 파일과 지난 대화를 AI가 필요할 때 찾아 쓰는 기능을 열면서, 이 정보를 어떻게 다루는지 개인정보처리방침에 담았어요. 두 기능은 <strong>선생님이 허용한 경우에만</strong> 동작하고, <strong>AI 맞춤 설정</strong>에서 언제든 끌 수 있어요.</p>
      <p>생기부 결과의 문장마다 어느 입력에서 나왔는지 보여주는 <strong>근거 보기</strong>를 열면서, 생성할 때 넣은 내용을 어떻게 보관하는지도 함께 담았어요.</p>

      <h3>시행일</h3>
      <p><strong>2026년 11월 2일(월)</strong>부터 바뀐 개인정보처리방침이 적용돼요.</p>

      <h3>무엇이 바뀌나요</h3>
      <ul>
        <li><strong>내 자료함 자동 모으기</strong> - 허용하면 채팅에 올린 문서 파일(한글·PDF·워드·엑셀·PPT·텍스트)의 사본을 내 자료함에 모아 둬요. 학생 명단·성적표·상담 기록·생활기록부처럼 학생 정보로 보이는 파일은 모으지 않아요.</li>
        <li><strong>지난 대화 찾아보기</strong> - 허용하면 학생 이름 등 개인정보를 가린 대화 검색용 요약을 만들어, 지난 대화가 필요한 요청에만 참고해요.</li>
        <li><strong>채팅 첨부 보유 기간</strong> - 채팅에 올린 파일은 그 대화를 지우거나 회원 탈퇴할 때까지 보관하고, 대화를 지우면 첨부도 함께 지워요.</li>
        <li><strong>동의 기록</strong> - 기능별 허용 여부와 바꾼 시각, 처리방침 버전을 기록해요.</li>
        <li><strong>생기부 근거 보기 자료</strong> - 생기부를 만들 때 넣은 내용과 첨부 파일에서 읽은 글을 연락처 등 개인정보를 가린 채로 생성 기록과 함께 보관해요. 원본 파일은 보관하지 않고, 생기부 기록을 지우거나 탈퇴하면 함께 지워요.</li>
      </ul>

      <h3>바뀌기 전과 후</h3>
      <table>
        <thead>
          <tr>
            <th>조항</th>
            <th>바뀌기 전</th>
            <th>바뀐 후</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>제1조 ① 수집 항목</td>
            <td>(없음)</td>
            <td>(허용한 경우) 채팅에 올린 문서 파일의 이름과 추출한 본문을 내 자료함에 모아 둔 사본, 학생 이름 등 개인정보를 가리고 만든 대화 검색용 요약</td>
          </tr>
          <tr>
            <td>제2조 처리 목적</td>
            <td>(없음)</td>
            <td>허용한 경우, 채팅에 올린 파일과 지난 대화에서 지금 요청에 필요한 내용을 찾아 AI 답변에 참고</td>
          </tr>
          <tr>
            <td>제3조 보유 기간</td>
            <td>(없음)</td>
            <td>채팅 첨부 파일: 그 대화를 삭제하거나 회원 탈퇴 시까지 / 내 자료함: 직접 삭제하거나 회원 탈퇴 시까지(무료는 자동으로 모은 파일을 최근 20개까지 남김) / 대화 검색용 요약: 원래 대화를 삭제하거나 회원 탈퇴 시까지</td>
          </tr>
          <tr>
            <td>제3조의5 (신설)</td>
            <td>(없음)</td>
            <td>허용한 경우에만 동작하고 각각 끌 수 있음, 학생 정보로 보이는 파일은 자동으로 모으지 않음, 필요한 부분만 개인정보를 가려 AI 제공사에 보냄, 광고·판매·모델 학습에 쓰지 않음</td>
          </tr>
          <tr>
            <td>제1조 ① 수집 항목 · 제3조 보유 기간 · 제3조의2 ⑦ (생기부 근거 보기)</td>
            <td>(없음)</td>
            <td>생기부 생성 때 입력한 내용과 첨부 파일에서 읽은 글(개인정보를 가린 형태)을 근거 보기와 문장 고치기에만 쓰고, 생기부 기록을 삭제하거나 회원 탈퇴할 때까지 보관. 원본 파일은 보관하지 않음. 근거를 찾을 때도 가린 글만 AI 제공사에 보냄</td>
          </tr>
        </tbody>
      </table>

      <h3>끄고 싶으시면</h3>
      <p><strong>AI 맞춤 설정 → AI가 찾아 쓰는 자료</strong>에서 '채팅에 올린 파일 모아 두기'와 '지난 대화 찾아보기'를 각각 끌 수 있어요. 끄면 그때부터 모으거나 찾지 않고, 이미 모아 둔 파일은 참고 자료에서 지울 수 있어요.</p>

      <h3>바뀐 방침 전문 보기</h3>
      <p><a href="/privacy-policy" style="color: #3182f6; font-weight: 600;">개인정보처리방침 보기</a></p>

      <h3>문의</h3>
      <p>바뀐 내용이 궁금하시면 개인정보 보호책임자에게 연락해 주세요.</p>
      <ul>
        <li><strong>이메일:</strong> angel@plactical.com</li>
        <li><strong>전화:</strong> 02-949-9158</li>
      </ul>
    `,
  },
  {
    id: 'school-review-teacher-submit-2026-10',
    date: '2026-10-25',
    title: '생기부 파일, 이제 주고받지 마세요 - 학교 생기부 검토에 선생님 직접 제출이 생겼어요',
    summary: '선생님마다 내가 쓴 글을 직접 올리고, 관리자는 선생님별 현황과 수정 요청·확인 끝을 한 화면에서 관리해요. 학교(엔터프라이즈) 요금제(12개월 · 선생님 10명 이상)에 추가 비용 없이 들어 있어요.',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>학기 말이면 생기부 파일을 메신저로 받고, 고칠 곳을 정리해 다시 보내고, 고친 파일을 또 받아 처음부터 읽으셨죠. <strong>학교 생기부 검토</strong>에서 이 과정을 한 화면에서 끝낼 수 있게 바꿨어요.</p>

      <h3>무엇이 바뀌나요</h3>
      <ul>
        <li><strong>선생님 직접 제출</strong> - 관리자가 제출 받기를 켜면, 선생님은 내 메뉴의 <strong>내 생기부 검토</strong>에서 내가 쓴 글을 직접 올려요. 담임이 아니어도 여러 반 세특·동아리 글을 올릴 수 있어요. 엑셀·한글·워드·PDF 그대로 올리면 돼요.</li>
        <li><strong>선생님별 현황</strong> - 선생님마다 올리기 전 · 검토 중 · 수정 요청 · 다시 올림 · 확인 끝으로 보여요. 안 올린 선생님이나 고칠 글이 남은 선생님께 알림 메일을 보낼 수 있어요(학생 이름은 넣지 않아요).</li>
        <li><strong>수정 요청이 쓴 선생님 화면에 바로</strong> - 관리자가 글마다 남긴 수정 요청과 메모를 그 글을 올린 선생님이 바로 봐요. 고친 파일을 다시 올리면 관리자에게는 바뀐 글만 다시 보여요.</li>
        <li><strong>우리 학교 기재 지침</strong> - 학교에서 쓰지 않기로 한 표현과 바꿀 말을 적어 두면 선생님 화면에 보이고, 올라온 글 점검에도 함께 들어가요.</li>
      </ul>

      <h3>선생님은 내 글만 봐요</h3>
      <ul>
        <li>선생님은 내가 올린 글과 관리자 메모만 봐요. 학교 전체는 학교 관리자만 봐요.</li>
        <li>다른 선생님이 올린 글이 섞인 파일은 그 글만 빼고 받고, 몇 개를 뺐는지 알려 드려요. 담임을 정해 두면 행동특성·자율·진로는 그 반 담임만 올려요.</li>
      </ul>

      <h3>요금 안내</h3>
      <ul>
        <li>학교 생기부 검토는 <strong>학교(엔터프라이즈) 요금제(12개월 · 선생님 10명 이상)</strong>에 들어 있어요.</li>
        <li>금액은 <strong>12개월 단체 단가 그대로</strong>(선생님 수 기준, 인원 할인 그대로)이고, 학교 생기부 검토는 추가 비용이 없어요.</li>
        <li>요금제 화면에서 도입 문의를 남기시면 12개월 견적서와 학교 생기부 검토 소개서를 메일로 바로 보내 드려요.</li>
      </ul>

      <h3>꼭 알아 두세요</h3>
      <ul>
        <li>AI 점검 결과는 초안이에요. 최종 판단과 수정은 선생님이 직접 해 주세요.</li>
        <li>같은 문장·기재요령·학교 지침 점검은 다시 볼 곳을 좁혀 주는 도구예요. 감사 통과를 보장하지 않아요.</li>
        <li>여기서 원본 기록이 바뀌지는 않아요. 원본을 고친 뒤 다시 올려 주세요.</li>
      </ul>

      <p>로그인 없이 <a href="/enterprise/school-review">가상 학교로 체험</a>해 보시고, <a href="/docs/whatquiz-school-review.pdf">소개서</a>와 <a href="/help/notice/update-2026-10-school-review">자세한 사용법</a>도 확인해 주세요.</p>
      <p>감사합니다.</p>
    `,
  },
  {
    id: 'privacy-policy-update-2026-10-newsletter',
    date: '2026-10-21',
    title: '개인정보처리방침 변경 안내 (2026.10.21 시행)',
    summary: '아침 교육 뉴스레터 구독 정보와 이메일 발송 위탁(Resend, 미국)을 방침에 담았어요.',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>매일 아침 교육 뉴스를 메일로 받아보실 수 있는 <strong>교육 뉴스레터</strong>를 시작하면서, 구독 정보를 어떻게 다루는지 개인정보처리방침에 담았어요. 그동안 따로 적혀 있지 않던 <strong>이메일 발송 위탁</strong>도 함께 공개해요.</p>

      <h3>시행일</h3>
      <p><strong>2026년 10월 21일(수)</strong>부터 바뀐 개인정보처리방침이 적용돼요.</p>

      <h3>무엇이 바뀌나요</h3>
      <ul>
        <li><strong>뉴스레터 처리 항목 공개</strong> - 이메일 주소, 동의 기록(동의 일시·문구·IP 주소·브라우저 정보), 로그인 상태에서 신청하면 회원 식별값</li>
        <li><strong>처리 목적 추가</strong> - 아침 교육 뉴스와 왓퀴즈 새 기능·이벤트 소식 발송, 수신동의 처리 결과와 2년마다 수신동의 확인 안내</li>
        <li><strong>보유 기간 공개</strong> - 수신거부하면 바로 지우고, 확정하지 않은 신청은 7일 뒤 지워요</li>
        <li><strong>이메일 발송 위탁 공개</strong> - 회원 안내·결제 서류·문의 답변 메일과 뉴스레터는 Plus Five Five, Inc.(서비스명 Resend, 미국)를 통해 보내요</li>
      </ul>

      <h3>바뀌기 전과 후</h3>
      <table>
        <thead>
          <tr>
            <th>조항</th>
            <th>바뀌기 전</th>
            <th>바뀐 후</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>제1조 ① 수집 항목</td>
            <td>(없음)</td>
            <td>8. 교육 뉴스레터 구독 시: 이메일 주소, 동의 기록(동의 일시, 동의한 문구와 버전, 신청할 때의 IP 주소와 브라우저 정보), 로그인 상태에서 신청하면 회원 식별값, 발송 기록(마지막 발송일, 수신동의 재확인 안내 일시)</td>
          </tr>
          <tr>
            <td>제1조 ② 수집 방법</td>
            <td>(없음)</td>
            <td>교육 뉴스 페이지의 '뉴스레터로 받기'에서 선생님이 이메일 주소를 직접 입력하고 동의하는 방식</td>
          </tr>
          <tr>
            <td>제2조 처리 목적</td>
            <td>(없음)</td>
            <td>교육 뉴스레터 발송(동의한 경우에만): 아침 교육 뉴스와 왓퀴즈 새 기능·이벤트 소식 발송, 구독 확인·처리 결과·2년마다 수신동의 확인 안내, 수신동의 증명과 부정 신청 방지</td>
          </tr>
          <tr>
            <td>제3조 보유 기간</td>
            <td>(없음)</td>
            <td>뉴스레터 구독 정보: 수신거부하면 즉시 파기, 7일 안에 확정하지 않은 신청은 자동 파기, 회원 탈퇴와 관계없이 수신거부할 때까지 보관</td>
          </tr>
          <tr>
            <td>제6조 국외 이전(이메일 발송)</td>
            <td>(없음)</td>
            <td>Plus Five Five, Inc.(Resend, privacy@resend.com) / 미국 / 받는 사람 이메일 주소, 메일 본문과 첨부 파일, 발송·수신 결과 기록 / 메일을 보낼 때마다 암호화 전송 / 발송 기록 30일 보관 후 삭제</td>
          </tr>
          <tr>
            <td>제7조 국외 이전 거부</td>
            <td>AI 서비스 이용 제한, 계약 해지 안내</td>
            <td>위 내용에 더해, 이메일 발송 위탁을 거부하면 안내 메일과 결제 서류를 메일로 받을 수 없음. 뉴스레터는 메일 맨 아래 '수신거부'로 바로 멈추고 구독 정보도 삭제</td>
          </tr>
        </tbody>
      </table>

      <p>뉴스 기사를 고르고 요약할 때 AI를 쓰지만, 구독하신 분의 이메일 주소 같은 개인정보는 AI 제공사에 보내지 않아요.</p>

      <h3>바뀐 방침 전문 보기</h3>
      <p><a href="/privacy-policy" style="color: #3182f6; font-weight: 600;">개인정보처리방침 보기</a></p>

      <h3>문의</h3>
      <p>바뀐 내용이 궁금하시면 개인정보 보호책임자에게 연락해 주세요.</p>
      <ul>
        <li><strong>이메일:</strong> angel@plactical.com</li>
        <li><strong>전화:</strong> 02-949-9158</li>
      </ul>
    `,
  },
  {
    id: 'privacy-policy-update-2026-11',
    date: '2026-10-18',
    title: '개인정보처리방침 변경 안내 (2026.10.18 시행)',
    summary: '학급 관리·서술형 채점·과제 제출방에서 다루는 학생 정보와 서버 위치를 방침에 담았어요.',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>학급 관리(학생 명단), 서술형 채점, 과제 제출방에서 선생님이 다루시는 <strong>학생 정보</strong>를 어떻게 처리하는지 개인정보처리방침에 자세히 담았어요.</p>

      <h3>시행일</h3>
      <p><strong>2026년 10월 18일(일)</strong>부터 바뀐 개인정보처리방침이 적용돼요.</p>

      <h3>무엇이 바뀌나요</h3>
      <ul>
        <li><strong>학생 정보 처리 항목 공개</strong> - 학급 명단(학생 이름·번호·이름 별칭), 서술형 채점 기록, 과제 제출방 제출물</li>
        <li><strong>처리 목적 추가</strong> - 학생별 기록(채점·제출물·생기부) 모아보기와, 선생님이 요청하면 이 기록을 근거로 생기부 초안 작성</li>
        <li><strong>수집 방법 추가</strong> - 기록에서 학생 이름을 고칠 때 저장되는 이름 별칭, 학생이 제출 링크에서 직접 내는 과제</li>
        <li><strong>보유 기간 공개</strong> - 학급 명단·채점 기록·제출물은 선생님이 지우거나 탈퇴할 때까지, 처리용 임시 파일은 1~7일</li>
        <li><strong>학생 정보 특칙 신설</strong> - 선생님이 요청한 범위에서만 처리하고, 명단은 AI 제공사에 보내지 않으며, 광고·판매·모델 학습에 쓰지 않아요</li>
        <li><strong>서버 위치 공개</strong> - 서버·파일 저장소는 미국(아이오와), 데이터베이스는 대한민국(서울)</li>
      </ul>

      <h3>바뀌기 전과 후</h3>
      <table>
        <thead>
          <tr>
            <th>조항</th>
            <th>바뀌기 전</th>
            <th>바뀐 후</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>제1조 ① 수집 항목</td>
            <td>(없음)</td>
            <td>7. 학급 관리·서술형 채점·과제 제출방 이용 시: 학생 이름·번호·이름 별칭·명단 이름·학년도와 학기, 답안 파일과 AI가 읽은 답안 글·점수·피드백, 학생이 입력한 이름·제출 파일·제출 일시. 학번·생년월일·연락처·성별·법정대리인 정보는 따로 요구하지 않음</td>
          </tr>
          <tr>
            <td>제1조 ② 수집 방법</td>
            <td>(없음)</td>
            <td>채점·생기부 기록에서 학생 이름을 고칠 때 이름 별칭이 학급 명단에 저장되는 방식, 학생이 과제 제출 링크에서 로그인 없이 이름과 과제를 직접 내는 방식</td>
          </tr>
          <tr>
            <td>제2조 처리 목적</td>
            <td>(없음)</td>
            <td>선생님의 학생 지도·평가 업무 지원: 학급 명단으로 학생 이름 맞추기, 서술형 채점과 결과 다시보기, 과제 제출 현황 확인, 학생별 기록 모아보기와 이를 근거로 한 생활기록부 초안 작성(선생님이 요청한 경우)</td>
          </tr>
          <tr>
            <td>제3조 보유 기간</td>
            <td>(없음)</td>
            <td>학급 명단·서술형 채점 기록·제출물: 선생님이 지우거나 탈퇴할 때까지(지난 학년도 명단은 이름 맞추기에 쓰지 않음). 처리용 임시 파일: 서술형 채점 1일, 생기부 생성 7일 뒤 자동 파기</td>
          </tr>
          <tr>
            <td>제3조 ④ 회원 탈퇴 시 삭제</td>
            <td>생기부 생성 기록, 검사 기록, 검사 사용 기록을 함께 삭제</td>
            <td>위 기록에 더해 학급 명단, 서술형 채점 기록과 답안 파일, 과제 제출방과 제출물도 함께 삭제</td>
          </tr>
          <tr>
            <td>제3조의4 학생 정보 처리 특칙</td>
            <td>(없음)</td>
            <td>신설: 선생님이 요청한 범위에서만 처리, 명단 대조는 회사 서버 안에서 하고 AI 제공사에 보내지 않음, 학생 화면에 명단·다른 학생 제출 여부를 보여주지 않음, 목적 외 이용 금지, 열람·정정·삭제 방법, 민감정보 입력 자제 안내, 학습지원 소프트웨어 선정 자료 제공</td>
          </tr>
          <tr>
            <td>제6조 국외 이전(Google)</td>
            <td>Google: 입력 텍스트, 첨부 파일 내용, 이용 로그 / AI 플랫폼 운영</td>
            <td>Google: 위 항목에 더해 회원 정보와 서비스 이용 중 입력·생성된 자료(학급 명단, 채점 기록, 제출물 포함) / 클라우드 서버 운영과 데이터 저장(Google Cloud·Firebase). 서버·파일 저장소 미국(아이오와), 데이터베이스 대한민국(서울)</td>
          </tr>
          <tr>
            <td>제8조 ④ 학생 정보의 성격</td>
            <td>(없음)</td>
            <td>학생 정보는 회사가 학생에게 직접 동의를 받아 모으는 정보가 아니라, 선생님·학교가 학교 업무로 처리하는 정보를 회사가 대신 처리하는 것. 제출방에서 학생에게 연락처나 법정대리인 정보를 요구하지 않음</td>
          </tr>
        </tbody>
      </table>

      <h3>바뀐 방침 전문 보기</h3>
      <p><a href="/privacy-policy" style="color: #3182f6; font-weight: 600;">개인정보처리방침 보기</a></p>

      <h3>문의</h3>
      <p>바뀐 내용이 궁금하시면 개인정보 보호책임자에게 연락해 주세요.</p>
      <ul>
        <li><strong>이메일:</strong> angel@plactical.com</li>
        <li><strong>전화:</strong> 02-949-9158</li>
      </ul>
    `,
  },
  {
    id: 'ceri-pilot-recruit-2026-10',
    date: '2026-10-16',
    title: '[모집 마감] 한국교원대 x 왓퀴즈AI 실증 연구 선생님 모집',
    summary: '10월 31일(토) 한국교원대 실증 연구 모집이 마감됐어요. 신청해 주신 선생님들 정말 감사해요.',
    isImportant: false,
    content: `
      <p>안녕하세요, 팀왓퀴즈입니다.</p>

      <div style="background: #f2f4f6; border: 1px solid #e5e8eb; border-radius: 12px; padding: 20px; margin: 16px 0;">
        <p style="color: #191f28; margin: 0 0 8px 0; font-size: 16px; font-weight: 700;">모집이 마감됐어요</p>
        <p style="margin: 0; color: #333d4b; line-height: 1.7;">10월 31일(토) 한국교원대 실증 연구에 함께할 선생님을 모두 모셨어요. 바쁜 학기 중에도 관심 갖고 신청해 주신 선생님들께 진심으로 감사드려요.</p>
      </div>

      <p>한국교원대학교 융합교육연구소(CERI)와 왓퀴즈AI가 함께하는 고등학교 교과 실증 연구예요. 왓퀴즈AI가 실제 학교 업무에서 얼마나 쓸모 있는지 함께 확인하고, 선생님들께 더 유용한 도구로 다듬을게요.</p>

      <h3>실증 연구 안내</h3>
      <ul>
        <li><strong>일시:</strong> 2026년 10월 31일(토) 14:00~16:00 (2시간)</li>
        <li><strong>장소:</strong> 한국교원대학교 교육연구관 509호 (대형강의실)</li>
        <li><strong>준비물:</strong> 개인 노트북과 충전기</li>
      </ul>
      <p>참여하시는 선생님께는 따로 연락드려요.</p>

      <h3>문의</h3>
      <ul>
        <li><strong>이메일:</strong> <a href="mailto:angel@plactical.com" style="color: #1a73e8;">angel@plactical.com</a></li>
        <li><strong>전화:</strong> 02-949-9158</li>
      </ul>

      <p>연구에서 나온 의견으로 왓퀴즈를 더 좋게 만들어 볼게요. 감사합니다.</p>
    `,
  },
  {
    id: 'saenggibu-commercial-use-law-2026',
    date: '2026-07-15',
    title: '학생부 상업적 이용 제한 법 개정과 왓퀴즈 생기부 기능 안내',
    summary: '교육부 보도자료의 핵심, 왓퀴즈가 지켜온 원칙, 입력 자료와 생성 결과의 처리 방식을 선생님께 투명하게 안내합니다.',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>최근 교육부의 학생부 상업적 이용 제한 보도자료가 발표된 뒤, 여러 선생님께서 “내가 입력한 학생 기록은 어디에 쓰이나요?”, “혹시 기업이 가공해서 판매하는 것은 아닌가요?”라고 물어보셨습니다.</p>
      <p>학생의 성장 기록은 단순한 데이터가 아니라 선생님의 오랜 관찰과 학생의 시간이 담긴 소중한 기록입니다. 그래서 이 질문을 가볍게 답할 수 없었습니다. 선생님께서 왓퀴즈를 믿고 맡겨주신 자료를 어떻게 다루는지, 그동안 지켜온 원칙과 이번에 더 강화한 부분을 숨김없이 말씀드립니다.</p>

      <h3>교육부 보도자료의 핵심</h3>
      <p>2026년 7월 29일부터 학생부를 사고팔거나, 입시 상담 상품과 유료 자료를 만드는 데 사용하는 일이 제한됩니다.</p>
      <p>다른 사람의 학생부를 모아 판매하거나, 학생부 자료로 AI를 다시 학습시키거나, 학원 홍보와 수강생 모집에 이용하는 경우가 주요 제한 대상입니다.</p>

      <h3>왓퀴즈는 학생부를 매매한 적이 없습니다</h3>
      <p><strong>왓퀴즈는 선생님이 입력한 학생 기록이나 생성된 생기부를 구매하거나 판매한 적이 없습니다.</strong></p>
      <p><strong>학생부를 제3자의 독자적인 영업, 입시 상담, 광고, 유료 자료 제작을 위해 제공한 적도 없으며, 앞으로도 그렇게 할 계획이 없습니다.</strong> 다른 학교나 다른 선생님의 결과를 만들기 위한 데이터로 돌려쓰지도 않습니다.</p>

      <h3>선생님의 자료로 AI를 학습시키지 않습니다</h3>
      <p><strong>선생님이 입력한 학생 기록과 생성된 생기부로 AI를 학습시키지 않습니다. 절대로요.</strong></p>
      <p>선생님의 자료는 요청하신 초안을 만들고 검사하는 그 순간에만 사용됩니다. <strong>그 외의 어떤 목적으로도 활용하지 않습니다.</strong> 학습, 통계 상품, 마케팅, 다른 서비스 개발 어디에도 쓰지 않습니다.</p>

      <h3>왓퀴즈는 입시 컨설팅 서비스가 아니라 교사의 보조 도구입니다</h3>
      <p>왓퀴즈의 생기부 기능은 선생님이 직접 관찰하고 평가한 누가기록, 수업 활동, 학생 산출물을 바탕으로 문장 초안을 만들거나 기재요령을 점검하도록 돕습니다.</p>
      <p>학생·학부모에게 합격 가능성, 학생부 강·약점, 지원 대학이나 입시 전략을 판매하지 않습니다. 합격생의 학생부를 수집해 비교하거나 추천 결과를 만드는 서비스도 아닙니다.</p>
      <p>2026학년도 학교생활기록부 기재요령도 AI 결과를 그대로 입력하는 행위는 금지하면서, 윤문 등 보조 수단으로 활용할 때에는 교사가 학생의 실제 수행, 허위·과장 여부, 기재요령 준수 여부를 최종 확인하도록 안내합니다. 왓퀴즈 역시 그 원칙 안에서 선생님의 판단을 돕는 도구로 설계되어 있습니다.</p>

      <h3>입력 자료와 생성 결과는 이렇게 처리합니다</h3>
      <h4>생기부 생성 기능</h4>
      <p>선생님이 입력한 관찰 기록과 생성된 결과는 선생님 본인의 기록 화면에서 다시 확인할 수 있도록 계정에 저장될 수 있으며, 본인 외에는 볼 수 없습니다. 이 자료를 판매하거나 입시 상품·광고에 이용하지 않으며, 입력한 생기부 자료로 AI를 다시 학습시키지도 않습니다.</p>

      <h4>생기부 검사 기능</h4>
      <p><strong>업로드한 원본 파일은 검사가 끝나면 왓퀴즈 서버에 남기지 않고 즉시 폐기합니다.</strong> 작성 중인 검사 초안은 다시 확인하고 수정할 수 있도록 기록에 저장될 수 있으며, 연락처 같은 개인정보는 자동으로 가립니다.</p>
      <p><strong>최종 확정된 학생부나 공식 발급본은 검사기에 업로드하지 말고, 선생님이 작성 중인 초안만 이용해주세요.</strong></p>

      <h3>이번 법 시행을 앞두고 추가로 확인하고 바꾼 부분</h3>
      <ul>
        <li><strong>원본 파일 미보관:</strong> 검사에 올린 원본 파일 자체는 별도 파일로 저장하지 않습니다.</li>
        <li><strong>개인정보 자동 보호 재점검:</strong> 연락처 같은 개인정보가 AI 요청 전에 자동으로 가려지는지 전 과정을 다시 확인했습니다.</li>
      </ul>

      <h3>자주 묻는 질문</h3>
      <h4>Q. 최근 일부 플랫폼이 생기부를 분석한 뒤 기업이 가공·판매했다는 이야기가 있습니다. 왓퀴즈도 자료를 모아 판매하나요?</h4>
      <p><strong>아닙니다.</strong> 왓퀴즈는 선생님이 입력한 학생 기록과 생성된 생기부를 판매한 적이 없고, 다른 기업의 입시 상담·상품 제작·광고를 위해 제공한 적도 없습니다. 앞으로도 학생부를 별도 상품이나 데이터 자산으로 판매할 계획이 없습니다.</p>

      <h4>Q. 입력한 자료로 AI가 학습하나요?</h4>
      <p><strong>아니요, 학습하지 않습니다.</strong> 선생님이 입력한 자료와 생성된 결과는 요청하신 작업을 처리하는 데에만 사용하고, AI 학습이나 그 외 다른 용도로는 일절 활용하지 않습니다.</p>

      <h4>Q. 생기부 AI 서비스가 유료이면 모두 금지되는 건가요?</h4>
      <p>서비스가 유료라는 이유만으로 모두 금지되는 것은 아닙니다. 교사의 관찰 자료로 기록 작성을 돕는 것과, 다른 사람의 학생부를 사서 입시 상담이나 유료 자료에 활용하는 것은 다릅니다.</p>

      <h4>Q. 왓퀴즈 생기부 기능을 계속 사용해도 되나요?</h4>
      <p>교사가 직접 관찰·평가한 자료로 초안을 만들고 최종 내용을 직접 확인하는 통상적인 업무 보조 방식으로 이용할 수 있습니다. 다만 학생부를 입시 상담, 판매, 유료 자료 제작, 수강생 모집 등 별도 영업 목적으로 이용해서는 안 됩니다.</p>

      <h4>Q. 검사기에 파일을 올리면 파일이 계속 저장되나요?</h4>
      <p>업로드한 원본 파일 자체는 별도 파일로 저장하지 않습니다. 다만 작성 중인 검사 초안은 기록에서 다시 확인할 수 있도록 저장될 수 있으며, 이 기록은 선생님 본인만 볼 수 있습니다. 최종 확정본이나 공식 발급본은 올리지 말고 작성 중인 초안만 이용해주세요.</p>

      <h3>공식 자료와 왓퀴즈 정책</h3>
      <ul>
        <li><a href="https://www.moe.go.kr/sn3hcv/doc.html?fn=54853642596693780f122bdfd3185acb&rs=/upload/synap/202607" target="_blank" rel="noopener noreferrer">교육부 보도자료 — ‘학생부 상업적 이용 제한, 공공의 진로·진학 상담으로 촘촘하게 채운다’ 원문 보기</a></li>
        <li><a href="https://law.go.kr/LSW/lsInfoP.do?ancYnChk=0&lsId=000900" target="_blank" rel="noopener noreferrer">국가법령정보센터 — 초·중등교육법</a></li>
        <li><a href="https://star.moe.go.kr/web/contents/m40100.do?id=107757&schM=view" target="_blank" rel="noopener noreferrer">학교생활기록부 종합지원포털 — 2026학년도 기재요령</a></li>
        <li><a href="/privacy-policy">왓퀴즈 개인정보처리방침</a></li>
        <li><a href="/terms-of-service">왓퀴즈 이용약관</a></li>
      </ul>

      <p style="font-size:14px;color:#6b7280;">본 안내는 왓퀴즈의 일반적인 서비스 구조와 공개된 교육부 자료를 설명하기 위한 것입니다. 학교 또는 교육청의 별도 보안 지침이 있다면 해당 지침을 함께 확인해주세요.</p>
      <p>왓퀴즈를 믿고 학생의 소중한 기록을 맡겨주신 선생님들께 진심으로 감사드립니다.</p>
      <p>그 믿음이 당연하다고 생각하지 않겠습니다. 눈에 보이는 기능뿐 아니라 보이지 않는 데이터 처리 과정까지 더 안전하게 살피고, 선생님께서 안심하고 본연의 교육에 집중하실 수 있도록 최선을 다하겠습니다.</p>
      <p>앞으로도 바뀌는 법과 현장의 목소리를 먼저 확인하고, 부족한 점이 있다면 숨기지 않고 고치며 투명하게 안내드리겠습니다. 감사합니다.</p>
    `,
  },
  {
    id: 'refund-policy-update-2026-04',
    date: '2026-04-25',
    title: '환불 정책 단순화 개정 안내 (2026.4.25 시행 / 30일 유예 보호 포함)',
    summary: '7일 이내 100% 자동 환불 / 차감 환불 폐지 + 시행 전 결제 회원 30일 유예 + 미성년자 특례',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>그동안 운영해온 <strong>사용량 기반 차감 환불 정책</strong>이 회원님께는 다소 복잡하고 예측이 어렵다는 의견을 많이 받았습니다. 회원의 권익을 더 두텁게 보장하고 환불 절차를 명료화하기 위해 환불 정책을 다음과 같이 <strong>단순화 개정</strong>합니다.</p>

      <h3>시행일</h3>
      <p><strong>2026년 4월 25일</strong>부터 변경된 환불 정책이 즉시 적용됩니다.</p>
      <p style="font-size: 14px; color: #6b7280; margin-top: 8px;">
        ※ 본 개정은 회원의 청약철회권을 더 두텁게 보장하는 방향(이용량과 무관하게 7일 이내 100% 환불)이므로 「약관의 규제에 관한 법률」 제3조에 따른 사전 명시 의무를 충족하면서 즉시 시행합니다.
      </p>

      <h3>📝 개정 배경</h3>
      <ul>
        <li><strong>고객 권익 강화:</strong> 사용 이력에 따른 차감 계산 없이 7일 이내 결제분은 100% 전액 환불받으실 수 있습니다.</li>
        <li><strong>예측 가능성:</strong> 단가표·차감 공식을 폐지하고, 7일 이내/초과의 단순한 두 가지 기준으로 통일했습니다.</li>
        <li><strong>법적 정합성:</strong> 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제1항(7일 청약철회권)과 제2항 제5호(디지털 콘텐츠 청약철회 제한)의 균형을 명확히 반영했습니다.</li>
      </ul>

      <h3>🔄 주요 변경사항 (변경 전 → 변경 후)</h3>
      <table>
        <thead>
          <tr>
            <th style="width: 30%;">항목</th>
            <th style="width: 35%;">변경 전 (2025.12.18 ~ 2026.4.24)</th>
            <th style="width: 35%;">변경 후 (2026.4.25~)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>7일 이내 환불</strong></td>
            <td>1회도 사용하지 않은 경우에 한해 100% 환불</td>
            <td><strong style="color: #059669;">사용 이력과 무관하게 100% 자동 환불</strong></td>
          </tr>
          <tr>
            <td><strong>7일 초과 환불</strong></td>
            <td>"기간"과 "사용량" 중 더 높은 비율로 차감 후 환불 + 위약금 10%</td>
            <td><strong style="color: #d97706;">자동 환불 불가 / 회사 귀책·서비스 장애 등 특별 사정은 별도 문의</strong></td>
          </tr>
          <tr>
            <td><strong>건당 단가표</strong></td>
            <td>생기부 500원, 채팅 100원 등 9종 단가 공개</td>
            <td><strong style="color: #059669;">전면 폐지</strong> (환불 산정에 사용량 단가를 사용하지 않음)</td>
          </tr>
          <tr>
            <td><strong>환불 신청 방법</strong></td>
            <td>마이페이지 자동 환불 + 차감액 사후 안내</td>
            <td><strong style="color: #059669;">마이페이지 → 구독 관리 → 환불 요청 즉시 처리 (7일 이내)</strong></td>
          </tr>
          <tr>
            <td>오남용 방지 조항</td>
            <td>매크로·계정 공유·반복 환불 등 6항목</td>
            <td>그대로 유지 (단, 단기 집중 이용 후 환불 방어 조항 1건 명문화)</td>
          </tr>
        </tbody>
      </table>

      <div style="background: #f0fff4; border: 1px solid #9ae6b4; border-radius: 12px; padding: 20px; margin: 16px 0;">
        <p style="color: #2f855a; margin: 0 0 8px 0; font-size: 16px; font-weight: 600;">✅ 회원에게 더 유리해진 점</p>
        <ul style="margin: 0; padding-left: 20px; color: #1f2937; line-height: 1.7;">
          <li>결제 후 7일 이내라면 <strong>이미 사용하셨더라도 100% 전액 환불</strong> (이용량 기반 차감 없음)</li>
          <li>마이페이지에서 <strong>버튼 한 번으로 자동 처리</strong> (별도 메일·계산 없음)</li>
          <li>위약금 10% 폐지</li>
        </ul>
      </div>

      <div style="background: #fffbeb; border: 1px solid #fcd34d; border-radius: 12px; padding: 20px; margin: 16px 0;">
        <p style="color: #d97706; margin: 0 0 8px 0; font-size: 16px; font-weight: 600;">⚠️ 7일 초과 시 유의사항</p>
        <p style="margin: 0 0 8px 0; color: #78350f; line-height: 1.7;">
          결제 후 7일이 지나면 마이페이지에서 자동 환불은 불가합니다. AI 서비스는 이용 즉시 외부 AI API 비용이 실시간으로 발생하는 디지털 콘텐츠로, 「전자상거래법」 제17조 제2항 제5호에 따라 청약철회가 제한될 수 있기 때문입니다.
        </p>
        <p style="margin: 0; color: #78350f; line-height: 1.7;">
          단, <strong>회사 귀책사유, 서비스 장애, 명백한 오류, 결제 시스템 문제 등 특별한 사정</strong>이 있는 경우 <a href="mailto:angel@plactical.com" style="color: #b45309; font-weight: 600;">angel@plactical.com</a>으로 문의하시면 사안별로 검토해 드립니다.
        </p>
      </div>

      <h3>📌 적용 대상</h3>
      <ul>
        <li><strong>2026년 4월 25일 이후 신규 결제분:</strong> 새 정책이 적용됩니다.</li>
        <li><strong>2026년 4월 25일 이전 결제분 (7일 이내 잔여):</strong> 결제일 기준 7일이 아직 남아 있는 경우 새 정책이 적용되어 더 유리하게 환불받으실 수 있습니다 (소급 적용).</li>
        <li><strong>2026년 4월 25일 이전 결제분 (7일 초과):</strong> 아래 "30일 유예 조항"에 따라 회원이 원하시는 경우 직전 정책(2025.12.18~2026.4.24 적용)에 따른 차감 환불을 신청하실 수 있습니다.</li>
        <li><strong>학교·기관 단체 구매(대량구매):</strong> 별도의 환불 절차가 적용되며, 발급된 쿠폰 중 사용되지 않은 분에 대해서만 환불이 가능합니다 (변경 없음).</li>
      </ul>

      <div style="background: #fffbeb; border: 1px solid #fcd34d; border-radius: 12px; padding: 20px; margin: 16px 0;">
        <p style="color: #92400e; margin: 0 0 8px 0; font-size: 16px; font-weight: 700;">🛡️ 30일 유예 조항 (시행 전 결제 회원 보호)</p>
        <p style="color: #78350f; margin: 0 0 8px 0; line-height: 1.7;">
          본 개정 시행일(2026년 4월 25일) 이전에 결제하셨고, 결제 후 7일이 경과한 회원이 본 개정 내용에 동의하지 않으시는 경우, <strong>시행일로부터 30일 이내(2026년 5월 25일까지)</strong>에 <a href="mailto:angel@plactical.com" style="color: #b45309; font-weight: 600;">angel@plactical.com</a>으로 환불 요청 시 직전 환불 정책(2025.12.18~2026.4.24 적용)에 따른 차감 환불을 적용해 드립니다.
        </p>
        <p style="color: #78350f; margin: 0; line-height: 1.7;">
          <strong>차감 환불 공식 (직전 정책):</strong><br/>
          환불 금액 = 결제 금액 - (기이용 금액 + 위약금 10%)<br/>
          기이용 금액 = Max(기간 기준, 사용량 기준)
        </p>
        <p style="color: #78350f; margin: 8px 0 0 0; font-size: 13px;">
          ※ 본 조항은 「약관의 규제에 관한 법률」 제3조의 회원 보호 정신과 「전자상거래법」 제17조의 청약철회권 균형을 반영한 자발적 보호 조치입니다.
        </p>
      </div>

      <div style="background: #f0f4ff; border: 1px solid #c7d2fe; border-radius: 12px; padding: 20px; margin: 16px 0;">
        <p style="color: #3730a3; margin: 0 0 8px 0; font-size: 16px; font-weight: 700;">👶 미성년자 결제에 관한 특례 (변경 없음, 신규 명시)</p>
        <p style="color: #1e3a8a; margin: 0; line-height: 1.7;">
          만 19세 미만 미성년자가 법정대리인 동의 없이 결제한 경우, 「민법」 제5조 및 「전자상거래법」 제17조 제1항 제1호에 따라 <strong>결제 후 경과 기간과 무관하게</strong> 청약철회 및 전액 환불이 가능합니다. 본 조항에 따른 환불은 angel@plactical.com으로 결제일·결제수단·법정대리인 신원 확인 자료를 첨부하여 신청해 주시기 바랍니다.
        </p>
      </div>

      <h3>🔍 약관 변경에 동의하지 않으시는 경우</h3>
      <p>본 환불 정책 개정 내용에 동의하지 않으시는 경우, 다음 두 가지 선택권을 보장해 드립니다:</p>
      <ol>
        <li><strong>회원 탈퇴:</strong> 시행일 이전까지 회원 탈퇴를 통해 이용 계약을 해지하실 수 있습니다.</li>
        <li><strong>30일 유예 조항 적용:</strong> 시행일 이전 결제분에 대해 시행일로부터 30일 이내 직전 정책에 따른 차감 환불을 신청하실 수 있습니다 (위 30일 유예 조항 참조).</li>
      </ol>
      <p>본 개정은 <strong>회원의 청약철회권을 더 두텁게 보장하는 방향</strong>이므로 별도의 거부권 행사 절차 없이 즉시 시행되며, 시행일 이후 서비스를 계속 이용하시는 경우 개정된 정책에 동의하신 것으로 간주됩니다. 다만 위 두 가지 선택권은 30일 유예 기간 내 보장됩니다.</p>

      <h3>⚖️ 법적 근거</h3>
      <ul>
        <li>「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제1항 (청약철회권) — 7일 이내 100% 환불 보장</li>
        <li>「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제1항 제1호 — 미성년자 결제 청약철회 특례</li>
        <li>「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제2항 제5호 — 디지털 콘텐츠 청약철회 제한 사유</li>
        <li>「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제6항 — 청약철회 제한 사유 사전 고지 의무</li>
        <li>「전자상거래 등에서의 소비자보호에 관한 법률」 제18조 — 3영업일 이내 환급 의무, 지연 시 연 20% 지연이자</li>
        <li>「약관의 규제에 관한 법률」 제3조 — 약관 명시·설명 의무 (변경 시 사전 명시)</li>
        <li>「민법」 제5조 — 미성년자의 법률행위에 대한 법정대리인 동의 및 취소권</li>
        <li>「콘텐츠이용자보호지침」 (문화체육관광부 고시) — 디지털 콘텐츠 청약철회 가이드라인</li>
      </ul>

      <h3>📜 변경된 환불 정책 전문</h3>
      <p><a href="/refund-policy" style="color: #3182f6; font-weight: 600;">변경된 환불 정책 전문 보기</a></p>

      <h3>📞 문의</h3>
      <p>본 개정과 관련하여 궁금한 점이 있으시면 아래로 문의해 주시기 바랍니다.</p>
      <ul>
        <li><strong>이메일:</strong> <a href="mailto:angel@plactical.com" style="color: #1a73e8;">angel@plactical.com</a></li>
        <li><strong>전화:</strong> 02-949-9158</li>
        <li><strong>한국소비자원 분쟁조정:</strong> (국번 없이) 1372 / <a href="https://www.ccn.go.kr" style="color: #1a73e8;" target="_blank" rel="noopener noreferrer">www.ccn.go.kr</a></li>
      </ul>

      <p style="margin-top: 24px; color: #6b7280; font-size: 14px;">
        ※ 직전 환불 정책 (2025.12.18 ~ 2026.4.24 적용) 본문은 <a href="/help/notice/refund-policy-update-2025-12" style="color: #1a73e8;">여기</a>에서 확인하실 수 있습니다.
      </p>

      <p style="margin-top: 24px; color: #6b7280;">왓퀴즈는 앞으로도 회원님의 권익을 두텁게 보호하기 위해 최선을 다하겠습니다.</p>
    `,
  },
  {
    id: 'ai-model-upgrade-2026-01',
    date: '2026-01-30',
    title: '서비스 개편 및 쿠폰 정책 변경 안내',
    summary: 'AI 서비스 업그레이드와 쿠폰 시스템 개편 안내',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>항상 왓퀴즈를 이용해 주시는 선생님들께 진심으로 감사드립니다.</p>
      <p>더 나은 AI 서비스 제공과 공정한 혜택 분배를 위해 <strong>서비스 및 쿠폰 정책을 개편</strong>하게 되었습니다.</p>
      
      <h3>🎫 쿠폰 정책 변경 안내</h3>
      
      <h4>기존 쿠폰 사용 기간</h4>
      <p>그동안 <strong>에듀테크 박람회, 전시회, 교사 연수</strong> 등 외부 행사에서 배포되었던 다양한 쿠폰들은 이번 시스템 개편에 따라 <strong>2026년 2월 28일까지만</strong> 사용이 가능합니다.</p>
      <ul>
        <li>보유 중인 쿠폰이 있으시다면 <strong>2월 28일 이전</strong>에 사용해 주세요.</li>
        <li>기한 이후 미사용 쿠폰은 자동 소멸됩니다.</li>
      </ul>
      
      <h4>새로운 무료체험 정책</h4>
      <p>앞으로는 <strong>모든 선생님께 공평하게 7일 무료체험</strong> 기회가 제공됩니다.</p>
      <ul>
        <li>원하실 때 <strong>"7일 무료 체험"</strong> 버튼을 클릭하여 PRO 기능을 체험하실 수 있습니다.</li>
        <li>행사 참여 여부와 관계없이 누구나 동일한 혜택을 받으실 수 있습니다.</li>
        <li>카드 등록 없이 바로 시작 가능하며, 체험 기간이 끝나도 자동 결제되지 않습니다.</li>
      </ul>
      
      <div style="background: #FAF5FF; border: 1px solid #DDD6FE; border-radius: 12px; padding: 20px; margin: 16px 0;">
        <p style="color: #7C3AED; margin: 0 0 8px 0; font-size: 15px; font-weight: 600;">무료 사용자이신가요?</p>
        <p style="color: #374151; margin: 0; font-size: 14px; line-height: 1.6;">PRO 기능이 필요하실 때 무료체험을 활용해보세요! AI 수업 도우미, 생기부 작성 등 PRO 기능 사용 시 나타나는 안내 창에서 <strong style="color: #7C3AED;">"7일 무료 체험"</strong> 버튼을 클릭하시면 됩니다. <span style="color: #6B7280;">(첫 사용자 1회 제공)</span></p>
      </div>
      
      <h4>향후 쿠폰 발급 방식</h4>
      <p>쿠폰은 다음과 같은 <strong>특별한 경우에만</strong> 발급됩니다:</p>
      <ul>
        <li><strong>학교·기관 단체 구매</strong> 시 개별 인증 쿠폰 발급</li>
        <li><strong>공식 파트너십 프로그램</strong> 참여 시 맞춤 혜택 제공</li>
        <li>모든 쿠폰은 <strong>암호화된 고유 코드</strong>로 생성되어 보안이 강화됩니다.</li>
      </ul>
      
      <h3>🤖 AI 서비스 업그레이드</h3>
      
      <h4>왜 이렇게 바꾸나요?</h4>
      <p>2025년 하반기부터 ${PRO_MODELS_TEXT} 등 <strong>차세대 AI 모델</strong>들이 출시되면서 AI 기술이 비약적으로 발전했습니다. 이러한 최신 모델들은 기존 대비 훨씬 정확하고 창의적인 답변을 제공하지만, 그만큼 <strong>운영 비용도 크게 증가</strong>하였습니다.</p>
      
      <p>실제로 OpenAI, Anthropic, Google 등 주요 AI 기업들이 2025년~2026년 사이 API 가격을 순차적으로 인상하였으며, 고성능 모델일수록 비용 부담이 커지고 있습니다. 왓퀴즈는 이러한 환경 변화 속에서도 <strong>선생님들께 최고 품질의 AI 서비스</strong>를 지속적으로 제공하기 위해 서비스 구조를 개편하게 되었습니다.</p>
      
      <h4>모든 선생님께 제공되는 기능</h4>
      <ul>
        <li><strong>빠른 모드</strong> - 빠르게 답변</li>
        <li><strong>웹 검색 기능</strong> - 최신 정보를 반영한 답변</li>
        <li><strong>기본 추론 기능</strong> - 논리적이고 체계적인 사고</li>
        <li>생기부 초안 생성, AI 수업 도우미 등 핵심 기능 모두 이용 가능</li>
      </ul>
      
      <h4>PRO 선생님께 추가 제공되는 기능</h4>
      <ul>
        <li><strong>${PRO_MODELS_TEXT}</strong> 등 최신 고성능 AI 모델</li>
        <li><strong>고급 추론 (Thinking)</strong> - 더 깊고 정교한 사고 과정</li>
        <li>파일 첨부, 장기 기억, 엑셀 일괄처리 등 고급 기능</li>
      </ul>
      
      <h3>정책 변경의 배경</h3>
      <p>이번 쿠폰 정책 변경은 다음과 같은 이유로 결정되었습니다:</p>
      <ul>
        <li><strong>공정한 혜택 제공</strong> - 행사 참여 여부와 관계없이 모든 선생님께 동일한 무료체험 기회 제공</li>
        <li><strong>서비스 품질 향상</strong> - 비용 절감분을 AI 모델 업그레이드와 서비스 안정성 강화에 재투자</li>
        <li><strong>보안 강화</strong> - 암호화된 개인별 쿠폰 시스템으로 부정 사용 방지</li>
        <li><strong>지속 가능한 운영</strong> - 증가하는 AI API 비용을 감당하면서도 합리적인 가격 유지</li>
      </ul>
      
      <h3>적용 시점</h3>
      <ul>
        <li><strong>기존 쿠폰 사용 마감</strong>: 2026년 2월 28일</li>
        <li><strong>새로운 무료체험 정책</strong>: 2026년 2월 1일부터 적용</li>
      </ul>
      
      <h3>마치며</h3>
      <p>왓퀴즈는 선생님들의 업무 부담을 덜어드리고, 더 많은 시간을 학생들과 함께할 수 있도록 돕는 것을 목표로 하고 있습니다.</p>
      <p>이번 변경이 다소 불편을 드릴 수 있지만, <strong>더 나은 AI 품질과 공정한 서비스</strong>로 보답하겠습니다. 항상 왓퀴즈를 믿고 이용해 주셔서 감사합니다.</p>
      
      <p style="margin-top: 32px; color: #5f6368;">
        문의사항이 있으시면 <a href="mailto:angel@plactical.com" style="color: #1a73e8;">angel@plactical.com</a>으로 연락해 주세요.
      </p>
    `,
  },
  {
    id: 'privacy-policy-update-2026-01',
    date: '2026-01-21',
    title: '개인정보처리방침 변경 안내 (2026.1.28 시행)',
    summary: '만 14세 미만 아동 보호, 쿠키, 파기 절차 등 대폭 강화',
    isImportant: true,
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>교육 서비스의 특성을 반영하여 개인정보 보호 수준을 한층 강화한 <strong>개인정보처리방침</strong>을 개정합니다.</p>
      
      <h3>시행일</h3>
      <p><strong>2026년 1월 28일</strong>부터 변경된 개인정보처리방침이 적용됩니다.</p>
      
      <h3>개정 배경</h3>
      <p>왓퀴즈는 교사 선생님들을 위한 에듀테크 서비스로서, 개인정보 보호에 관한 국내 법령 및 규제 기준을 철저히 준수하고자 합니다. 이번 개정은 「개인정보 보호법」의 필수 기준을 모두 충족하고, 교육 서비스 특성에 맞는 보호 조치를 강화하기 위해 진행됩니다.</p>
      
      <h3>주요 변경 내용</h3>
      
      <h4>1. 만 14세 미만 아동의 개인정보 보호 (제8조 신설)</h4>
      <ul>
        <li>만 14세 미만 아동의 직접 서비스 가입을 허용하지 않습니다.</li>
        <li>만 14세 미만 아동의 개인정보 수집 시 <strong>법정대리인의 동의</strong>를 필수로 받습니다.</li>
        <li>법정대리인의 열람, 정정, 삭제, 처리정지 요청 권리를 명시합니다.</li>
      </ul>
      
      <h4>2. 개인정보 수집 항목 및 수집 방법 상세화 (제1조 개정)</h4>
      <ul>
        <li>수집 항목을 카테고리별로 세분화 (회원 가입, 자동 수집, 유료 서비스, AI 서비스, 고객 문의)</li>
        <li>수집 방법을 구체적으로 명시 (직접 입력, 자동 수집, 고객센터 등)</li>
      </ul>
      
      <h4>3. 개인정보 파기 절차 및 방법 상세화 (제3조 개정)</h4>
      <ul>
        <li>파기 절차: 목적 달성 후 별도 DB 이관 → 보관 기간 경과 후 파기</li>
        <li>파기 방법: 전자적 파일 복구 불가능 삭제, 종이 문서 분쇄 파기</li>
        <li>법령별 보유 기간 및 근거 표로 명시</li>
      </ul>
      
      <h4>4. 쿠키(자동 수집 장치) 조항 신설 (제10조 신설)</h4>
      <ul>
        <li>쿠키의 정의 및 사용 목적 안내</li>
        <li>쿠키 설정 거부 방법 상세 안내 (브라우저별 설정 방법 포함)</li>
        <li>쿠키 거부 시 서비스 이용 제한 사항 고지</li>
      </ul>
      
      <h4>5. 보유기간 법적 근거 명시 (제3조 개정)</h4>
      <table>
        <thead>
          <tr>
            <th>보유 항목</th>
            <th>보유 기간</th>
            <th>근거 법령</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>회원 탈퇴 후 재가입 제한</td>
            <td>30일</td>
            <td>내부 방침</td>
          </tr>
          <tr>
            <td>표시·광고에 관한 기록</td>
            <td>6개월</td>
            <td>전자상거래법</td>
          </tr>
          <tr>
            <td>계약/청약 철회 기록</td>
            <td>5년</td>
            <td>전자상거래법</td>
          </tr>
          <tr>
            <td>대금결제/재화 공급 기록</td>
            <td>5년</td>
            <td>전자상거래법</td>
          </tr>
          <tr>
            <td>소비자 불만/분쟁 기록</td>
            <td>3년</td>
            <td>전자상거래법</td>
          </tr>
          <tr>
            <td>접속 로그, IP 정보</td>
            <td>3개월</td>
            <td>통신비밀보호법</td>
          </tr>
        </tbody>
      </table>
      
      <h4>6. 권익침해 구제방법 상세화 (제13조 개정)</h4>
      <ul>
        <li>개인정보침해 신고센터: (국번없이) 118</li>
        <li>개인정보 분쟁조정위원회: 1833-6972</li>
        <li>대검찰청: (국번없이) 1301</li>
        <li>경찰청: (국번없이) 182</li>
      </ul>
      
      <h3>변경된 방침 미리보기</h3>
      <p>2026년 1월 28일 이전에도 변경될 개인정보처리방침을 미리 확인하실 수 있습니다.</p>
      <p><a href="/privacy-policy?preview=v3" style="color: #3182f6; font-weight: 600;">변경될 개인정보처리방침 미리보기</a></p>
      
      <h3>문의</h3>
      <p>개인정보처리방침 변경에 대한 문의사항은 개인정보 보호책임자에게 연락 주시기 바랍니다.</p>
      <ul>
        <li><strong>이메일:</strong> angel@plactical.com</li>
        <li><strong>전화:</strong> 02-949-9158</li>
      </ul>
      
      <p style="margin-top: 24px; color: #6b7280;">왓퀴즈는 앞으로도 이용자의 개인정보를 안전하게 보호하기 위해 최선을 다하겠습니다.</p>
    `,
  },
  {
    id: 'file-attachment-limit-2025-12',
    date: '2025-12-16',
    title: 'AI 서비스 이용 안내 (Rate Limit 관련)',
    summary: 'AI 사용량 급증으로 인한 Rate Limit 대응 및 대체 모델 안내',
    content: `
      <h3>먼저 감사의 말씀을 드립니다</h3>
      <p>왓퀴즈를 사랑해주시는 많은 선생님들 덕분에 서비스가 예상보다 훨씬 빠르게 성장하고 있습니다. 진심으로 감사드립니다.</p>
      
      <h3>무슨 일이 있었나요?</h3>
      <p>왓퀴즈는 OpenAI, Google, Anthropic 등의 <strong>AI 서비스(LLM)</strong>를 활용하여 운영되고 있습니다. 이러한 AI 서비스는 <strong>일정 시간 내 처리할 수 있는 요청량에 한도(Rate Limit)</strong>가 있습니다.</p>
      <ul>
        <li>최근 왓퀴즈 사용량이 <strong>빠르게 증가</strong>하면서, AI 서비스의 처리 한도에 자주 도달하게 되었습니다.</li>
        <li>일부 사용자의 <strong>비정상적인 대용량 파일 업로드 및 과도한 요청</strong>도 발견되었습니다.</li>
        <li>이로 인해 정상적으로 이용하시는 선생님들께 <strong>응답 지연, 오류 등의 불편</strong>이 발생하였습니다.</li>
      </ul>
      
      <h3>어떻게 해결하나요?</h3>
      <p>왓퀴즈는 평소 <strong>가장 성능이 좋은 최신 AI 모델</strong>을 제공하고 있습니다. 그러나 일부 악용 사례 및 사용량 급증으로 인해 <strong>Rate Limit에 도달하는 경우</strong>, 자동으로 <strong>다른 최적의 대체 모델</strong>로 결과를 제공합니다.</p>
      <p style="margin-top: 12px; padding: 12px; background: #fff3cd; border-radius: 8px; border-left: 4px solid #ffc107;">
        <strong>참고:</strong> 대체 모델 사용 시 결과물이 평소와 다소 다르게 느껴질 수 있습니다. 양해 부탁드립니다.
      </p>
      <p style="margin-top: 12px;">Rate Limit은 보통 <strong>수 분 ~ 최대 24시간</strong> 내에 자동으로 해제됩니다. 이를 방지하기 위해 아래 제한 사항을 적용하고 있습니다.</p>
      
      <div style="margin-top: 16px; padding: 12px; background: #eef4ff; border-radius: 8px; border-left: 4px solid #3182f6;">
        <strong>2026년 10월부터 AI 채팅 첨부가 바뀌었어요</strong>
        <ul style="margin: 8px 0 0;">
          <li>PDF는 200MB, 한글·워드·엑셀·PPT 같은 문서는 100MB까지 올릴 수 있어요.</li>
          <li>20만 자가 넘는 파일(PDF, 한글, 워드, 엑셀, PPT, 텍스트·HTML 등)도 끝까지 읽고, 질문에 맞는 부분을 찾아 답해요.</li>
          <li>스캔 PDF와 그림 위주 PPT도 30쪽(장) 뒤를 물어보면 그 부분을 읽어요.</li>
          <li>생기부·채점 같은 다른 기능은 기능마다 한도가 달라요.</li>
        </ul>
        <a href="/help/notice/update-2026-10-bigfile" style="display: inline-block; margin-top: 8px; color: #3182f6; font-weight: 600;">큰 파일 업데이트 자세히 보기</a>
      </div>

      <h3>적용된 제한 사항 (2025년 12월 기준)</h3>
      <table>
        <thead>
          <tr>
            <th>항목</th>
            <th>제한</th>
            <th>설명</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>파일 첨부 개수</td>
            <td>최대 10개</td>
            <td>한 번에 업로드 가능한 파일 수</td>
          </tr>
          <tr>
            <td>파일 크기</td>
            <td>최대 30MB</td>
            <td>단일 파일 크기 (Free·Pro 동일)</td>
          </tr>
          <tr>
            <td><strong>텍스트 파일</strong><br/>(PDF, Excel, HWP, PPT 등)</td>
            <td>최대 200,000자</td>
            <td>텍스트 추출 가능한 파일은 문자수만 제한<br/>(초과 시 앞부분만 분석)</td>
          </tr>
          <tr>
            <td><strong>이미지 PDF</strong><br/>(스캔 문서 등)</td>
            <td>최대 30페이지, 30MB</td>
            <td>텍스트 추출 불가능한 PDF<br/>(초과 시 앞부분만 분석)</td>
          </tr>
          <tr>
            <td><strong>이미지 PPT</strong><br/>(이미지 위주)</td>
            <td>최대 30슬라이드</td>
            <td>텍스트가 거의 없는 PPT<br/>(초과 시 앞부분만 분석)</td>
          </tr>
          <tr>
            <td><strong>이미지 파일</strong></td>
            <td>최대 20MB</td>
            <td>JPG, PNG 등 이미지</td>
          </tr>
        </tbody>
      </table>
      <p style="margin-top: 12px; padding: 12px; background: #e8f5e9; border-radius: 8px; border-left: 4px solid #4caf50;">
        <strong>참고:</strong> 텍스트가 포함된 PDF, PPT, Excel, HWP 파일은 페이지/슬라이드 수와 관계없이 <strong>문자수만 제한</strong>됩니다. 단일 첨부 글자수 한도는 <strong>200,000자</strong>입니다 (파일 크기는 30MB 동일). 대부분의 교육 자료는 제한 내에서 충분히 분석 가능합니다.
      </p>
      
      <h3>현재 진행 상황</h3>
      <p>왓퀴즈 팀은 현재 <strong>OpenAI, Google, Anthropic에 긴급하게 Rate Limit 상향 요청</strong>을 진행하고 있습니다. 예상보다 빠르게 서비스가 성장하고 있어, 더 높은 처리 한도를 요청 중입니다.</p>
      <p>빠른 시일 내에 해결하여 앞으로 이런 불편이 발생하지 않도록 최선을 다하겠습니다.</p>
      
      <h3>사과와 약속</h3>
      <p>정상적으로 서비스를 이용해주시는 대다수의 선생님들께 불편을 드리게 되어 <strong>정말 죄송합니다.</strong></p>
      <p>악용 방지 시스템을 보완하고 API 한도를 늘려, 가능한 빠른 시일 내에 정상화할 수 있도록 최선을 다하겠습니다.</p>
      
      <h3>앞으로의 다짐</h3>
      <p>왓퀴즈는 선생님들의 수업 준비 시간을 줄여드리기 위해 탄생한 서비스입니다. 앞으로도 선생님들께서 더 편리하고 안정적으로 이용하실 수 있도록 꾸준히 개선해 나가겠습니다.</p>
      <p><strong>많은 사랑과 관심 부탁드립니다.</strong> 더 나은 서비스로 보답하겠습니다.</p>
      
      <p style="margin-top: 20px; color: #6b7280;">문의사항이 있으시면 <a href="mailto:angel@plactical.com" style="color: #4263eb;">angel@plactical.com</a>으로 연락해주세요.</p>
    `,
    isImportant: true
  },
  {
    id: 'refund-policy-update-2025-12',
    date: '2025-12-11',
    title: '환불 정책 변경 안내 (2025.12.18 시행 · 2026.4.25 폐지)',
    summary: '[폐지됨] AI 서비스 비용 구조를 반영한 사용량 기반 환불 정책',
    content: `
      <div style="background: #fef2f2; border: 2px solid #fca5a5; border-radius: 12px; padding: 20px; margin-bottom: 24px;">
        <p style="color: #991b1b; margin: 0 0 8px 0; font-size: 16px; font-weight: 700;">본 정책은 2026년 4월 25일자로 폐지되었습니다</p>
        <p style="color: #7f1d1d; margin: 0 0 12px 0; line-height: 1.7;">
          본 공지에 안내된 <strong>사용량 기반 차감 환불 · 건당 단가표 · 위약금 10% 정책은 2026년 4월 25일부로 단순화 개정</strong>되어 더 이상 적용되지 않습니다. 현재는 <strong>7일 이내 100% 자동 환불 / 7일 초과 별도 문의</strong> 정책이 적용됩니다.
        </p>
        <p style="margin: 0;">
          <a href="/help/notice/refund-policy-update-2026-04" style="color: #b91c1c; font-weight: 600; text-decoration: underline;">현행 환불 정책 변경 안내 (2026.4.25 시행) 보기</a>
        </p>
        <p style="margin: 8px 0 0 0;">
          <a href="/refund-policy" style="color: #b91c1c; font-weight: 600; text-decoration: underline;">현행 환불 정책 전문 보기</a>
        </p>
        <p style="color: #7f1d1d; margin: 12px 0 0 0; font-size: 13px;">
          ※ 본 공지는 약관 변경 이력 보존을 위해 그대로 유지됩니다.
        </p>
      </div>

      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>AI 서비스의 특수한 비용 구조를 합리적으로 반영하고, 대다수 선량한 이용자의 권익을 보호하기 위해 환불 정책을 개정합니다.</p>
      
      <h3>시행일</h3>
      <p><strong>2025년 12월 18일</strong>부터 변경된 환불 정책이 적용됩니다.</p>
      
      <h3>개정 배경</h3>
      <p>생성형 AI 서비스는 기존 SaaS와 달리 <strong>사용자의 요청마다 실시간으로 API 비용이 발생</strong>하는 변동비 구조입니다. 기존의 '7일 이내 무조건 전액 환불' 정책은 이러한 비용 구조를 반영하지 못해, 일부 오남용 사례가 발생하고 있습니다.</p>
      
      <h3>주요 변경 내용</h3>
      
      <h4>1. 미사용 시 전액 환불 (기존과 동일)</h4>
      <ul>
        <li>결제 후 7일 이내, AI 서비스를 1회도 사용하지 않은 경우 100% 환불</li>
      </ul>
      
      <h4>2. 사용 개시 후 차감 환불 (변경)</h4>
      <ul>
        <li>AI 서비스를 1회 이상 사용한 경우, <strong>'기간'과 '사용량' 중 더 높은 비율</strong>로 차감 후 환불</li>
        <li>환불 금액 = 결제 금액 - (기이용 금액 + 위약금 10%)</li>
      </ul>
      
      <h4>3. AI 생성 건당 단가 공개</h4>
      <p><strong>생기부 AI</strong></p>
      <table>
        <thead>
          <tr>
            <th>서비스</th>
            <th>건당 단가</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>AI 생기부 생성 (개별/일괄)</td>
            <td>500원</td>
          </tr>
          <tr>
            <td>AI 생기부 검수</td>
            <td>200원</td>
          </tr>
        </tbody>
      </table>
      
      <p style="margin-top: 16px;"><strong>AI 채팅</strong></p>
      <table>
        <thead>
          <tr>
            <th>서비스</th>
            <th>건당 단가</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>AI 채팅 메시지 (10회당)</td>
            <td>100원</td>
          </tr>
          <tr>
            <td>파일 업로드 분석</td>
            <td>200원</td>
          </tr>
          <tr>
            <td>이미지 분석</td>
            <td>300원</td>
          </tr>
        </tbody>
      </table>
      
      <p style="margin-top: 16px;"><strong>실험실 (Beta)</strong></p>
      <table>
        <thead>
          <tr>
            <th>서비스</th>
            <th>건당 단가</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>AI 서술형 채점</td>
            <td>300원</td>
          </tr>
          <tr>
            <td>AI 답안 채점 (1명당)</td>
            <td>100원</td>
          </tr>
          <tr>
            <td>AI 이미지 생성</td>
            <td>500원</td>
          </tr>
        </tbody>
      </table>
      
      <p style="margin-top: 16px;"><strong>기타</strong></p>
      <table>
        <thead>
          <tr>
            <th>서비스</th>
            <th>건당 단가</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>AI 퀴즈/학습지 생성</td>
            <td>300원</td>
          </tr>
          <tr>
            <td>AI 콘텐츠 분석</td>
            <td>200원</td>
          </tr>
        </tbody>
      </table>
      
      <h4>4. AI 특성 면책</h4>
      <ul>
        <li>AI 답변의 부정확성(환각 현상)은 서비스 하자가 아닙니다</li>
        <li>기대 수준 미달, 사용 후 단순 변심은 환불 사유가 아닙니다</li>
      </ul>
      
      <h3>기존 정책 적용 대상</h3>
      <p>2025년 12월 17일 이전에 구독한 고객님께는 기존 정책이 적용됩니다.</p>
      
      <h3>문의</h3>
      <p>환불 정책에 대한 문의사항은 고객센터(angel@plactical.com)로 연락 주시기 바랍니다.</p>
    `,
  },
  {
    id: 'terms-of-service-update-2025-12',
    date: '2025-12-11',
    title: '이용약관 변경 안내',
    summary: 'AI 서비스 관련 조항 추가',
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>AI 서비스 이용에 관한 권리·의무 관계를 명확히 하고 회원님의 권리를 보호하기 위해 이용약관을 개정합니다.</p>
      
      <h3>시행일</h3>
      <p><strong>2025년 12월 18일</strong>부터 변경된 이용약관이 적용됩니다.</p>
      
      <h3>개정 사유</h3>
      <ul>
        <li><strong>AI 서비스 용어 정의 추가</strong>: 입력 데이터(Input), AI 결과물(Output) 등 용어 정의</li>
        <li><strong>AI 서비스 기술적 한계 고지</strong>: 확률적 생성 특성, 정확성 미보증 사항 명시</li>
        <li><strong>지식재산권 조항 신설</strong>: AI 결과물의 권리 관계 명확화</li>
        <li><strong>AI 관련 금지행위 추가</strong>: 위법 콘텐츠 생성, 역공학 금지 등</li>
        <li><strong>면책 조항 강화</strong>: AI 서비스 관련 면책 사항 명시</li>
      </ul>
      
      <h3>주요 변경 내용</h3>
      
      <h4>1. AI 서비스의 기술적 한계 (제5조 신설)</h4>
      <ul>
        <li>AI 서비스는 확률적 모델에 기반하여 작동</li>
        <li>생성된 정보의 정확성, 완전성을 보증하지 않음</li>
        <li>회원은 AI 결과물을 검토 후 사용할 책임이 있음</li>
      </ul>
      
      <h4>2. 지식재산권 (제6조 신설)</h4>
      <ul>
        <li>입력 데이터: 회원에게 저작권 귀속</li>
        <li>AI 결과물: 회원이 자유롭게 활용 가능</li>
      </ul>
      
      <h4>3. AI 관련 금지행위 (제7조 개정)</h4>
      <ul>
        <li>위법 콘텐츠 생성 금지</li>
        <li>AI 결과물로 타인을 기망하는 행위 금지</li>
        <li>역공학 및 경쟁 AI 모델 개발 금지</li>
      </ul>
      
      <h3>동의 및 이의 제기</h3>
      <p>개정된 약관 내용에 동의하지 않으시는 경우, 회원 탈퇴를 통해 이용 계약을 해지하실 수 있습니다. 시행일까지 별도의 거부 의사를 표시하지 않고 서비스를 계속 이용하시는 경우, 개정된 약관에 동의한 것으로 간주됩니다.</p>
      
      <h3>문의</h3>
      <p>본 개정과 관련하여 궁금한 점이 있으시면 고객센터로 문의해 주시기 바랍니다.</p>
    `,
  },
  {
    id: 'privacy-policy-update-2025-12',
    date: '2025-12-11',
    title: '개인정보처리방침 변경 안내',
    summary: '개인정보 국외 이전 사항 투명성 강화',
    content: `
      <p>안녕하세요, 왓퀴즈입니다.</p>
      <p>왓퀴즈는 현재 제공 중인 AI 서비스의 개인정보 처리 사항을 보다 투명하게 안내드리고자 개인정보처리방침을 개정합니다.</p>
      
      <h3>시행일</h3>
      <p><strong>2025년 12월 18일</strong>부터 변경된 개인정보처리방침이 적용됩니다.</p>
      
      <h3>개정 사유</h3>
      <ul>
        <li><strong>국외 이전 사항 명시</strong>: AI 서비스 제공을 위해 위탁한 국외 업체(OpenAI, Anthropic, Google)의 정보를 상세히 공개합니다.</li>
        <li><strong>투명성 강화</strong>: 「개인정보 보호법」 제28조의8에 따라 국외 이전되는 개인정보 항목, 이전 목적, 보유 기간 등을 명확히 안내합니다.</li>
        <li><strong>정보주체 권리 안내</strong>: 국외 이전에 대한 거부권 행사 방법 및 그에 따른 효과를 안내합니다.</li>
      </ul>
      
      <h3>주요 변경 내용</h3>
      
      <h4>1. 개인정보 처리 위탁 (국외)</h4>
      <p>AI 서비스 제공을 위해 아래 국외 업체에 개인정보 처리를 위탁합니다.</p>
      <table>
        <thead>
          <tr>
            <th>수탁업체</th>
            <th>위탁 업무</th>
            <th>이전 국가</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>OpenAI, L.L.C.</td>
            <td>AI 모델 기반 응답 생성</td>
            <td>미국</td>
          </tr>
          <tr>
            <td>Anthropic, PBC</td>
            <td>AI 언어 모델 기반 텍스트 분석</td>
            <td>미국</td>
          </tr>
          <tr>
            <td>Google LLC</td>
            <td>AI 플랫폼 및 클라우드 인프라</td>
            <td>미국</td>
          </tr>
        </tbody>
      </table>
      
      <h4>2. 이전되는 개인정보 항목</h4>
      <ul>
        <li>서비스 이용 시 입력한 텍스트(프롬프트)</li>
        <li>서비스 이용 기록</li>
      </ul>
      
      <h4>3. 이전 목적</h4>
      <p>AI 기반 생기부 생성, AI 상담 등 서비스 제공을 위한 데이터 처리 (위탁자의 지시에 따른 처리만 수행)</p>
      
      <h4>4. 보유 및 이용 기간</h4>
      <p>위탁 목적 달성 시까지 (안전성 모니터링을 위해 최대 30일 보관 후 파기)</p>
      
      <h3>국외 이전 거부권 안내</h3>
      <p>고객님께서는 개인정보 국외 이전을 거부하실 수 있습니다.</p>
      <ul>
        <li><strong>거부 방법</strong>: 고객센터 또는 개인정보 보호 담당부서로 연락</li>
        <li><strong>거부 시 효과</strong>: AI 기반 서비스(AI 생기부 생성, AI 상담 등) 이용이 제한될 수 있습니다.</li>
      </ul>
      
      <h3>문의</h3>
      <p>본 개정과 관련하여 궁금한 점이 있으시면 개인정보 보호책임자에게 문의해 주시기 바랍니다.</p>
    `,
  },
  {
    id: 'privacy-policy-previous-2025-12',
    date: '2025-12-18',
    title: '개인정보처리방침 (2025.12.18 ~ 2026.1.27 적용)',
    summary: '이전 개인정보처리방침 전문 (AI 국외 이전 명시)',
    content: `
      <p>본 개인정보처리방침은 <strong>2025년 12월 18일부터 2026년 1월 27일까지</strong> 적용되었던 방침입니다.</p>
      <p>2026년 1월 28일부터는 <a href="/privacy-policy">새로운 개인정보처리방침</a>이 적용됩니다.</p>
      
      <hr style="margin: 24px 0; border: none; border-top: 1px solid #e8eaed;" />
      
      <p>상세 내용은 아래 링크에서 확인하실 수 있습니다.</p>
      <p><a href="/privacy-policy?preview=v2" style="color: #3182f6;">2025.12.18 ~ 2026.1.27 적용 개인정보처리방침 전문 보기</a></p>
      
      <h3>주요 내용 요약</h3>
      <ul>
        <li><strong>개인정보 국외 이전 조항 신설</strong> - AI 서비스 제공을 위한 국외 이전 사항 공개</li>
        <li><strong>국외 이전 거부권 안내</strong> - 거부 방법 및 효과 명시</li>
        <li><strong>국외 수탁사 정보 공개</strong> - OpenAI, Anthropic, Google 등</li>
      </ul>
    `,
  },
  {
    id: 'privacy-policy-previous-2025-01',
    date: '2025-01-15',
    title: '개인정보처리방침 (2025.1.15 ~ 2025.12.17 적용)',
    summary: '이전 개인정보처리방침 전문',
    content: `
      <p>본 개인정보처리방침은 <strong>2025년 1월 15일부터 2025년 12월 17일까지</strong> 적용되었던 방침입니다.</p>
      <p>2025년 12월 18일부터는 <a href="/privacy-policy?preview=new">새로운 개인정보처리방침</a>이 적용됩니다.</p>
      
      <hr style="margin: 24px 0; border: none; border-top: 1px solid #e8eaed;" />
      
      <h3>제1조 (개인정보 수집 항목 및 처리목적)</h3>
      <p>플랙티컬 주식회사('왓퀴즈')는 다음의 목적을 위하여 개인정보를 처리합니다.</p>
      <p><strong>수집하는 개인정보 항목:</strong></p>
      <ul>
        <li>필수항목: 구글 계정 정보(이메일, 이름, 프로필 사진)</li>
        <li>자동수집: 서비스 이용기록, 접속 IP, 쿠키, 접속일시</li>
        <li>결제정보: 결제수단 정보(토스페이먼츠를 통해 처리)</li>
        <li>사용자 입력: AI 서비스 이용 시 입력하는 텍스트 정보</li>
      </ul>
      <p><strong>처리목적:</strong></p>
      <ol>
        <li>회원 가입 및 관리</li>
        <li>AI 서비스 제공</li>
        <li>결제 및 정산</li>
        <li>고객 지원</li>
        <li>서비스 개선</li>
      </ol>
      
      <h3>제2조 (개인정보의 처리 및 보유기간)</h3>
      <ul>
        <li>회원정보: 회원탈퇴 후 1년</li>
        <li>결제정보: 전자상거래법에 따라 5년</li>
        <li>서비스 이용기록: 회원탈퇴 후 1년</li>
        <li>고객 문의 기록: 문의 완료 후 3년</li>
      </ul>
      
      <h3>제3조 (개인정보의 제3자 제공)</h3>
      <p>회사는 개인정보를 제3자에게 제공하지 않습니다.</p>
      
      <h3>제4조 (개인정보처리의 위탁)</h3>
      <ul>
        <li>위탁업체: 토스페이먼츠(Toss Payments)</li>
        <li>위탁업무: 결제 처리, 구독 관리</li>
      </ul>
      
      <h3>제5조 (정보주체의 권리·의무 및 행사방법)</h3>
      <p>정보주체는 회사에 대해 언제든지 개인정보 열람, 정정·삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다.</p>
      
      <h3>제6조 (개인정보의 안전성 확보조치)</h3>
      <ul>
        <li>데이터 암호화</li>
        <li>접근 권한 관리</li>
        <li>보안 모니터링</li>
      </ul>
      
      <h3>제7조 (개인정보보호책임자)</h3>
      <ul>
        <li>성명: 강연구</li>
        <li>직책: 대표이사</li>
        <li>이메일: angel@plactical.com</li>
        <li>전화: 02-949-9158</li>
      </ul>
    `,
  },
  {
    id: 'terms-of-service-previous-2024-12',
    date: '2024-12-20',
    title: '이용약관 (2024.12.20 ~ 2025.12.17 적용)',
    summary: '이전 이용약관 전문',
    content: `
      <p>본 이용약관은 <strong>2024년 12월 20일부터 2025년 12월 17일까지</strong> 적용되었던 약관입니다.</p>
      <p>2025년 12월 18일부터는 <a href="/terms-of-service?preview=new">새로운 이용약관</a>이 적용됩니다.</p>
      
      <hr style="margin: 24px 0; border: none; border-top: 1px solid #e8eaed;" />
      
      <h3>제1조 (목적)</h3>
      <p>이 약관은 플랙티컬 주식회사(이하 "회사")가 제공하는 왓퀴즈 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
      
      <h3>제2조 (정의)</h3>
      <ol>
        <li>"서비스"란 회사가 제공하는 AI 기반 퀴즈 생성, 학습지 생성, 수행평가 자료 생성, AI 채팅 등의 교육 관련 서비스를 의미합니다.</li>
        <li>"이용자"란 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
        <li>"회원"이란 회사에 개인정보를 제공하여 회원등록을 한 자를 말합니다.</li>
        <li>"Pro 구독"이란 기간제 결제를 통해 모든 서비스를 제한 없이 이용할 수 있는 유료 서비스를 의미합니다.</li>
      </ol>
      
      <h3>제3조 (회원가입)</h3>
      <p>이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</p>
      
      <h3>제4조 (서비스 이용)</h3>
      <p>회사는 다음과 같은 서비스를 제공합니다:</p>
      <ul>
        <li>AI 퀴즈 생성 서비스</li>
        <li>자유형 학습지 생성 서비스</li>
        <li>수행평가 자료 생성 서비스</li>
        <li>AI 선생님 채팅 서비스</li>
        <li>생활기록부 작성 지원 서비스</li>
      </ul>
      
      <h3>제5조 (Pro 구독 서비스)</h3>
      <ul>
        <li>3개월 플랜: 60,000원</li>
        <li>6개월 플랜: 110,000원</li>
        <li>12개월 플랜: 200,000원</li>
      </ul>
      <p>구독 요금은 선택한 기간에 대해 일회성 결제되며, 자동 갱신되지 않습니다.</p>
      
      <h3>제6조 (결제 및 환불)</h3>
      <p>환불 정책 (전자상거래법 제17조 준수):</p>
      <ul>
        <li>구독 후 7일 이내: 100% 전액 환불</li>
        <li>구독 후 7일 경과: 사용하지 않은 기간 일할 계산 환불</li>
      </ul>
      
      <h3>제7조 (회사의 의무)</h3>
      <p>회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 지속적이고 안정적으로 서비스를 제공하는데 최선을 다하여야 합니다.</p>
      
      <h3>제8조 (회원의 의무)</h3>
      <p>이용자는 허위 내용의 등록, 타인의 정보 도용, 저작권 침해 등의 행위를 하여서는 안 됩니다.</p>
      
      <h3>제9조 (저작권의 귀속)</h3>
      <ul>
        <li>회사가 작성한 저작물에 대한 저작권은 회사에 귀속합니다.</li>
        <li>이용자가 서비스를 통해 생성한 콘텐츠에 대한 저작권은 이용자에게 귀속됩니다.</li>
      </ul>
    `,
  },
  {
    id: 'refund-policy-previous-2024-12',
    date: '2024-12-20',
    title: '환불 정책 (2024.12.20 ~ 2025.12.17 적용)',
    summary: '이전 환불 정책 전문',
    content: `
      <p>본 환불 정책은 <strong>2024년 12월 20일부터 2025년 12월 17일까지</strong> 적용되었던 정책입니다.</p>
      <p>2025년 12월 18일부터는 <a href="/refund-policy?preview=new">새로운 환불 정책</a>이 적용됩니다.</p>
      
      <hr style="margin: 24px 0; border: none; border-top: 1px solid #e8eaed;" />
      
      <h3>제1조 (환불 정책의 목적)</h3>
      <p>이 환불 정책은 플랙티컬 주식회사가 제공하는 왓퀴즈 Pro 구독 서비스의 환불 기준과 절차를 명확히 합니다.</p>
      
      <h3>제2조 (환불 기준)</h3>
      <h4>7일 이내 청약철회권</h4>
      <ul>
        <li>구독 시작일로부터 7일 이내</li>
        <li>서비스 이용량과 무관하게 100% 전액 환불</li>
      </ul>
      
      <h4>7일 경과 후</h4>
      <ul>
        <li>사용하지 않은 기간에 대해 일할 계산 환불</li>
        <li>계산식: (전체 구독료 ÷ 전체 구독일수) × 남은 일수</li>
      </ul>
      
      <h3>제3조 (환불 제외 사항)</h3>
      <ul>
        <li>이용약관 위반으로 인한 서비스 중단</li>
        <li>허위 정보 제공으로 인한 계약 해지</li>
        <li>반복적인 가입/환불 시도</li>
      </ul>
      
      <h3>제4조 (환불 신청 방법)</h3>
      <ul>
        <li>마이페이지 → 구독 관리 → 환불 요청</li>
        <li>이메일: angel@plactical.com</li>
        <li>전화: 02-949-9158</li>
      </ul>
      <p>환불 처리: 신청일로부터 3-5 영업일 이내</p>
      
      <h3>제5조 (소비자 분쟁 해결)</h3>
      <ul>
        <li>한국소비자원 소비자분쟁조정위원회: 1372</li>
        <li>온라인 신청: www.ccn.go.kr</li>
      </ul>
    `,
  },
];
